import Modal from "../../designComponents/Modal";
import {
  AcceptButton,
  LabelText,
  SectionTitle,
} from "../Properties/Details/styles";
import { Input, InputGroup } from "./styles";

export interface PricingSettings {
  perDayRate: number;
  weeklyDiscountRate: number;
  monthlyDiscountRate: number;
  currency: "EUR";
  flatFee: number;
  percentageFee: number;
  stripeFeePercentage: number;
  stripeFeeRate: number;
  clickInterval?: number;
  verificationFlatFee?: number;
  verificationPercentageFee?: number;
  lookupFlatFee?: number;
  lookupPercentageFee?: number;
  rentisityFlatFee?: number;
}
function AddPromotion({
  isOpen,
  onClose,
  onAddPress,
  setData,
  initialValues,
}: {
  isOpen: boolean;
  onClose: () => void;
  onAddPress: () => void;
  setData: React.Dispatch<React.SetStateAction<PricingSettings>>;
  initialValues: PricingSettings;
}) {
  const handleChange = (field: keyof PricingSettings, value: string) => {
    const numValue = parseFloat(value) || 0;
    setData((prev) => ({
      ...prev,
      [field]: numValue,
    }));
  };
  return (
    <Modal
      isOpen={isOpen}
      halfWidth={true}
      onClose={onClose}
      title="Add Promotion Data"
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <SectionTitle>Promotion Fee</SectionTitle>
          <InputGroup>
            <LabelText>Per Day Rate (€)</LabelText>
            <Input
              type="number"
              value={initialValues.perDayRate}
              onChange={(e) => handleChange("perDayRate", e.target.value)}
              placeholder="Enter per day rate"
            />
          </InputGroup>

          <InputGroup>
            <LabelText>Weekly Discount (%)</LabelText>
            <Input
              type="number"
              value={initialValues.weeklyDiscountRate}
              onChange={(e) =>
                handleChange("weeklyDiscountRate", e.target.value)
              }
              placeholder="Enter weekly discount"
              min="0"
              max="100"
            />
          </InputGroup>

          <InputGroup>
            <LabelText>Monthly Discount (%)</LabelText>
            <Input
              type="number"
              value={initialValues.monthlyDiscountRate}
              onChange={(e) =>
                handleChange("monthlyDiscountRate", e.target.value)
              }
              placeholder="Enter monthly discount"
              min="0"
              max="100"
            />
          </InputGroup>
          <InputGroup>
            <LabelText>View Click Interval (Per/hr)</LabelText>
            <Input
              type="number"
              value={initialValues.clickInterval}
              onChange={(e) => handleChange("clickInterval", e.target.value)}
              placeholder="Enter View Click Interval"
              min="0"
              max="100"
            />
          </InputGroup>
        </div>
      </div>
      <AcceptButton onClick={onAddPress}>Save</AcceptButton>
    </Modal>
  );
}

export default AddPromotion;
